import React from "react";

const PageNotFound = () => {
  return <div>PAGE NOT FOUND!</div>;
};

export default PageNotFound;
